export default __webpack_public_path__ + "static/media/StatusNurseFill.478f641b.svg";